import _ from "lodash";
import { eventBus } from "@/main";
import { scatter, layout } from "plotly-js-material-design-theme";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    xUnits: undefined,
    elements: [],
    noPlotMsg: undefined,
    annotations: undefined,
    plotRange: [],
    plot: undefined,
    clickMode: "new",
    rangeLock: false,
    lastClickedElementSrc: undefined,
    lastSelectedFeature: undefined,
    menuValue: undefined,
    // activeAxes: [],
  },
  getters: {
    units: (state) => {
      return _.uniq(
        _.map(
          _.reverse(
            _.sortBy(state.elements, (x) => {
              return x.visible == true;
            })
          ),
          "units"
        )
      );
    },
    axes: (state, getters) => {
      return _.map(getters.units, (un, idx) => ({
        side: idx >= 1 ? "right" : "left",
        // title: un == "m" ? "Level" : "",
        ticksuffix: un,
        zerolinewidth: 1,
        zerolinecolor: "#bdbdbd",
        automargin: true,
        // positions: idx >= 1 ? 1 - 0.15 * (idx - 1) : undefined
      }));
    },
    extraLayoutOpts: (state) => {
      if (!_.isEmpty(state.elements)) {
        return _.first(state.elements).extraLayoutOpts;
      }
    },
    plotlyPlot: (state, getters) => {
      let plotarr = !_.isEmpty(state.elements)
        ? {
            data: _.map(
              state.elements,
              ({
                x,
                y,
                text,
                mode,
                hovertemplate,
                line,
                marker,
                units,
                fill,
                name,
                type,
                visible,
                connectgaps,
              }) => {
                // ;

                let unIdx = _.findIndex(getters.units, (l) => l == units);
                return scatter({
                  x,
                  y,
                  text: text || "",
                  connectgaps,
                  name,
                  type,
                  fill,
                  // _.includes(name, "precip") || _.includes(name, "rain")
                  //   ? "bar"
                  // : type,
                  mode,
                  hovertemplate: hovertemplate || `%{y:.2f} ${units}`,
                  line,
                  marker,
                  // line: {
                  //   color: 5,
                  //   width: 3,
                  // },
                  yaxis: unIdx >= 1 ? `y${unIdx + 1}` : "y",
                  visible: !_.isUndefined(visible) ? visible : true,
                });
              }
            ),
            layout: layout({
              theme: "seaborn",
              annotations: state.annotations,
              showlegend: true,
              autosize: true,
              hovermode: "x unified",
              legend: { orientation: "h", font: { size: 11 } },
              bargap: state.bargap,
              margin: {
                l: 70,
                r: 70,
                b: 250,
                t: 25,
                // pad: 8
              },
              // expand the different yaxes
              ..._.reduce(
                getters.axes,
                (result, ax, idx) => {
                  if (idx >= 1) {
                    ax.overlaying = "y";
                    ax.hoverformat = ".2f";
                    ax.anchor = "free";
                    ax.position = 1 - 0.06 * (idx - 1);
                  }

                  result[`yaxis${idx >= 1 ? idx + 1 : ""}`] = {
                    ...ax,
                  };
                  return result;
                },
                {}
              ),
              xaxis: {
                // title: state.xUnits == "time" ? "Time" : "Distance",
                ticksuffix: state.xUnits == "time" ? "" : ` ${state.xUnits}`,
                domain: [0, 1 - Math.max(getters.units.length - 2, 0) * 0.06],
              },
              ...getters.extraLayoutOpts,
            }),
            options: {
              responsive: true,
              displayModeBar: false,
            },
          }
        : undefined;

      let shapes = [];
      _.forEach(state.elements, (el, idx) => {
        if (el.thresholds) {
          let unIdx = _.findIndex(getters.units, (l) => l == el.units);
          shapes.push(
            ..._.map(el.thresholds, (threshold) => ({
              type: "line",
              xref: "paper",
              x0: 0,
              y0: threshold,
              x1: 1,
              y1: threshold,
              line: {
                color: plotarr.layout.colorway[idx],
                width: 2,
                dash: "dot",
              },
              yref: unIdx >= 1 ? `y${unIdx + 1}` : "y",
            }))
          );
        }
      });
      _.forEach(state.elements, (el, idx) => {
        if (el.rangeMarkers) {
          shapes.push(
            ..._.map(el.rangeMarkers, (rangeMarker) => ({
              type: "line",
              yref: "paper",
              y0: 0,
              x0: rangeMarker,
              y1: 1,
              x1: rangeMarker,
              line: {
                color: "grey",
                width: 2,
                dash: "dot",
              },
            }))
          );
        }
      });

      // rangeMarkers
      Vue.set(plotarr.layout, "shapes", _.flatten(shapes));

      return plotarr;
    },
    plot: (state, getters) =>
      state.noPlotMsg
        ? state.noPlotMsg
        : !_.isEmpty(state.elements)
        ? getters.plotlyPlot
        : undefined,
    plotSrcs: (state) => {
      return _.map(state.elements, "src");
    },
    uniquePlotSrcs: (state) => {
      let val = _.map(state.elements, "src");
      let unique = _.uniq(val);
      return unique;
    },
    clickMode: (state) => {
      return state.clickMode;
    },
    inControl: (state, getters) => {
      let controllers = _.uniqBy(
        _.map(getters.plotSrcs, (x) => _.join(_.take(_.split(x, ":"), 2), ":"))
      );
      return controllers.length == 1 ? _.first(controllers) : undefined;
    },
    noPlotMsg: (state) => {
      return state.noPlotMsg;
    },
    lastClickedElementSrc: (state) => {
      return state.lastClickedElementSrc;
    },
    lastSelectedFeature: (state) => {
      return state.lastSelectedFeature;
    },
    menuValue: (state) => {
      return state.menuValue;
    },
  },
  mutations: {
    setActiveAxes: (state, value) => {
      state.activeAxes = value;
    },
    toggleRangeLock: (state) => (state.rangeLock = !state.rangeLock),
    setBargap: (state, bargap) => {
      state.bargap = bargap;
    },
    clearBargap: (state) => (state.bargap = NaN),
    addPlot: (state, els) => {
      state.lastClickedElementSrc = els[0].src;
      let xUnits = els[0].xUnits;

      if (state.xUnits === xUnits) {
        // TODO: to add or not to add ?
        state.elements.push(...els);
        console.log("state.elements", state.elements);
      } else {
        // TODO: to warn or not to warn?

        state.elements = els;
        state.xUnits = xUnits;
      }
      state.noPlotMsg = undefined;
      state.clickMode = "new";
    },
    newPlot: (state, els) => {
      if (!_.isEmpty(els) && Array.isArray(els)) {
        let annotations = _.remove(els, "text");
        state.lastClickedElementSrc = els[0].src;
        state.elements = els;
        state.xUnits = els[0].xUnits;
        state.noPlotMsg = undefined;
        state.annotations = annotations;
      } else if (
        !_.isEmpty(els) &&
        !_.isEmpty(els.elements) &&
        !els.hasAnnotations
      ) {
        els = els.elements;
        state.lastClickedElementSrc = els[0].src;
        state.elements = els;
        state.xUnits = els[0].xUnits;
        state.noPlotMsg = undefined;
      }
    },
    setNoPlotMsg: (state, val) => (state.noPlotMsg = val),
    clearPlot: (state) => {
      state.elements = [];
      state.xUnits = undefined;
      state.noPlotMsg = undefined;
      state.bargap = NaN;
    },
    setPlotRange: (state, val) => (state.plotRange = val),
    setClickMode: (state, val) => (state.clickMode = val),
    removeSrc: (state, src) => {
      state.elements = _.filter(state.elements, (el) => el.src != src);
    },
    setLastSelectedFeature: (state, val) => (state.lastSelectedFeature = val),
    setMenuValue: (state, val) => (state.menuValue = val),
  },
  actions: {},
};
